import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=a5df252c&scoped=true&"
import script from "./ChatBox.vue?vue&type=script&lang=js&"
export * from "./ChatBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=a5df252c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5df252c",
  null
  
)

export default component.exports